import { Handle, Position } from "@xyflow/react";

type customeNodeType = {
  data: any;
  id: string;
};

const CustomNode = ({ data, id }: customeNodeType) => {
  return (
    <div className="flex flex-col gap-2 bg-white p-2 justify-center rounded-lg">
      {/* A handle for incoming edges */}
      <Handle type="target" position={Position.Top} />
      <div>
        <span className="font-semibold">Telegram ID: </span>
        <span className="">{data.label}</span>
      </div>
      {/* A handle for outgoing edges */}
      <Handle type="source" position={Position.Bottom} />
    </div>
  );
};

export default CustomNode;
